import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=01d6f70e&scoped=true&"
import script from "./ContentHeader.vue?vue&type=script&lang=js&"
export * from "./ContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContentHeader.vue?vue&type=style&index=0&id=01d6f70e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d6f70e",
  null
  
)

export default component.exports